/**
 *
 * @param color
 * @param opacity
 * @returns {*|string}
 */
const getColor = (color, opacity = 1) => {
    if(color ===  null || color === undefined)
        return `rgba(255,255,255,${opacity})`;

    if(isRgb(color)){
        return `rgba(${color}, ${opacity}%)`;
    }

    return color;
}

/**
 *
 * @param opacity
 * @returns {string}
 */
const getOpacity = (opacity) => {

    if(opacity?.endsWith('%'))
        opacity = opacity?.replace('%', '');

    if(opacity ===  null
        || opacity === undefined
        || isNaN(opacity))
        return '100%';

    return `${opacity}%`;
}

/**
 * Verify if color is rgb
 * @param color
 * @returns {boolean}
 */
const isRgb = (color) => {
    if(color === null || typeof color !==  'string')
        return false;

    const pattern = /^\d{1,3},\d{1,3},\d{1,3}$/;
    return pattern.test(color.replaceAll(/\s+/g, ''))
}

/**
 *
 * @param color
 * @param opacity
 * @param url
 * @returns {string}
 */
const getImageWithColor = (color, opacity, url) => {
        const isRgb = StyleHelper.isRgb(color)

        if(!isRgb || !url || !opacity)
            return  `linear-gradient(to right, rgba(244,255,255, 0), rgba(244,255,255, 0)) , url('${url}')`;

        opacity = StyleHelper.getOpacity(opacity);

        color  = `rgba(${color}, ${opacity})`;

        return  `linear-gradient(to right, ${color}, ${color}) , url('${url}')`
}

export const  StyleHelper  = {
    getColor,
    getOpacity,
    isRgb,
    getImageWithColor
}
